module.exports = __webpack_public_path__ + "static/media/soldout.7700781e.svg";